import { Input } from "@components";
import { CurrencyInput } from "@components/CurrencyInput";

export default function TextForm({ text, input_configs, onChange }) {
  const is_number = ["currency", "number"].includes(input_configs?.type);
  const InputComponent = is_number ? CurrencyInput : Input;

  return (
    <>
      <InputComponent
        value={text}
        onChange={(e, m, v) => {
          const value = is_number ? v : e === null ? "" : e.target.value;
          onChange(value);
        }}
        autoFocus
        className="w-100 mb-0"
        {...input_configs}
      />
    </>
  );
}
